// extracted by mini-css-extract-plugin
export default {"video":"gK8cy","videoText":"j3FoA","videoContainer":"gDaNV"};